/* @flow */

import React, { Component } from 'react';

export default class LegalDocs extends Component {
  render() {
    return (
      <div style={styles.container}>
        <iframe
          src="https://bit.ly/funilylegaldocs"
          height="100%"
          width="100%"
          frameborder="0"
        ></iframe>
      </div>
    );
  }
}

const styles = {
  container: {
    flex: 1,
    height: "100vh"
  },
  iframe: {
    height: "100%",
    width: "100%"
  }
}



// WEBPACK FOOTER //
// ./src/components/LegalDocs.js